module.exports = __webpack_public_path__ + "img/Barlow-Bold.aa061d6a.svg";